import { render } from "./AddSubscription.vue?vue&type=template&id=f3342986&ts=true"
import script from "./AddSubscription.vue?vue&type=script&lang=ts"
export * from "./AddSubscription.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/thomas/Workspace/SushiEden/SushiEden.Admin.Vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__